
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cases/remit",
      function () {
        return require("private-next-pages/cases/remit/index.tsx");
      }
    ]);
  